import { useQuery } from "@tanstack/react-query";
import { gqlRequest } from "@/api/graphql/request";
import {
  DASHBOARD_SUMMARY,
  DASHBOARD_SPARKLINES,
} from "@/api/graphql/operations/dashboard";

interface DashboardSummary {
  totalKeywords: number;
  totalChannels: number;
  totalContents: number;
  avgEnhancedScore: number;
  activeKeywords: number;
  recentSearches: number;
}

interface DashboardSparkline {
  label: string;
  values: number[];
}

export function useKpis() {
  return useQuery({
    queryKey: ["dashboard", "kpis"],
    queryFn: () =>
      gqlRequest<{ dashboardSummary: DashboardSummary }>(
        DASHBOARD_SUMMARY,
      ).then((d) => d.dashboardSummary),
    staleTime: 60_000,
  });
}

export function useSparklines() {
  return useQuery({
    queryKey: ["dashboard", "sparklines"],
    queryFn: () =>
      gqlRequest<{ dashboardSparklines: DashboardSparkline[] }>(
        DASHBOARD_SPARKLINES,
      ).then((d) => d.dashboardSparklines.map((s) => s.values)),
    staleTime: 60_000,
  });
}
